import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm, getFormValues } from 'redux-form';
import Input from '../../components/Input';
import { validateRequired, validatePasswordsMatch } from '../../helpers';

class PasswordForm extends React.Component {
  render() {
    const { handleSubmit, formValues } = this.props;
    const newPassword = formValues ? formValues.newPassword : undefined;

    return (
      <Form onSubmit={handleSubmit}>
        {!this.props.hideCurrent && (
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="password"
                  name="currentPassword"
                  label="Current Password"
                  validate={[validateRequired]}
                />
              </Col>
            </FormGroup>
          </Row>
        )}

        <Row>
          <FormGroup>
            <Col sm={12} className="form-input hide-form-label">
              <label htmlFor="password">Password</label>
              <sub className="subtext">
                Minimum of 8 characters. Must contain at least one number, one
                uppercase, and one lowercase letter.
              </sub>
              <Field
                component={Input}
                type="password"
                name="newPassword"
                validate={[validateRequired]}
                id="password"
              />
            </Col>
          </FormGroup>
        </Row>

        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="password"
                name="passwordConfirmation"
                label="Confirm New Password"
                validate={val => validatePasswordsMatch(newPassword, val)}
              />
            </Col>
          </FormGroup>
        </Row>

        <Row>
          <Col sm={12}>
            <Button
              bsStyle="primary"
              type="submit"
              className="relative-padding"
              disabled={this.props.isSaving}
            >
              {this.props.isSaving ? 'Saving...' : 'Save'}
            </Button>
          </Col>
        </Row>
        <br />
        {this.props.message && (
          <div className={`alert alert-${this.props.messageType}`}>
            {this.props.message}
          </div>
        )}
      </Form>
    );
  }
}

// Decorate the form component
PasswordForm = reduxForm({
  form: 'passwordForm'
})(PasswordForm);

const mapStateToProps = state => {
  return {
    formValues: getFormValues('passwordForm')(state)
  };
};

export default connect(mapStateToProps)(PasswordForm);



// WEBPACK FOOTER //
// ./src/containers/account/PasswordForm.js